module.exports = __webpack_public_path__ + "static/img/api_03.9223b224.svg";